import React from "react";
import Head from "next/head";
import configSelector from "../../external/configSelector";

interface SeoDataProps {
  title: string;
  description: string;
  keywords: string;
}

interface OpenGraphDataProps {
  title: string;
  description: string;
  image: string;
  url: string;
}

function SeoData({
  seoData,
  openGraphData,
}: {
  seoData: SeoDataProps;
  openGraphData?: OpenGraphDataProps;
}) {
  const logo = configSelector.getBizLogoURL();
  const siteName = configSelector.getBizName();
  const fbAppId = configSelector.getFacebookLogin()?.appID;

  let description = openGraphData?.description || seoData?.description;
  description =
    description && description.length > 150
      ? description.substring(0, 150) + "..."
      : description;

  const ogTitle = openGraphData?.title || seoData?.title;
  const ogImage = openGraphData?.image || logo;
  const ogUrl = openGraphData?.url;

  return (
    <Head>
      <title>{openGraphData?.title || seoData?.title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={seoData?.keywords} />

      {/* discord */}
      {siteName && <meta property="og:site_name" content={siteName} />}

      {/* Facebook/Open Graph */}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {description && <meta property="og:description" content={description} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogUrl && <link rel="canonical" href={ogUrl} />}
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      <meta property="og:type" content="website" />
      {fbAppId && <meta property="fb:app_id" content={fbAppId} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {ogUrl && <meta name="twitter:site" content={ogUrl} />}
      {ogTitle && <meta name="twitter:title" content={ogTitle} />}
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Head>
  );
}

export default SeoData;
